import cn from 'classnames'
import Link, { LinkProps } from 'next/link'
import { forwardRef, ComponentPropsWithoutRef } from 'react'

import styles from './LinkWrapper.module.scss'

export type LinkWrapperProps = { disabled?: boolean } & LinkProps & Omit<ComponentPropsWithoutRef<'a'>, keyof LinkProps>

const LinkWrapper = forwardRef<HTMLAnchorElement, LinkWrapperProps>(
  (
    { href, as, replace, scroll, shallow, passHref, prefetch, locale, children, className, disabled, ...props },
    ref
  ) => {
    return (
      <Link
        href={href}
        as={as}
        replace={replace}
        scroll={scroll}
        shallow={shallow}
        passHref={passHref}
        prefetch={prefetch}
        locale={locale}
        ref={ref}
        className={cn(styles.root, { [styles.disabled]: disabled }, className)}
        {...props}
      >
        {children}
      </Link>
    )
  }
)

export default LinkWrapper
